export const DetailPageKey = 'DetailPageKey';
